export default __webpack_public_path__ + "static/media/audio_release.b20eca0c.jpg";